/* eslint-disable no-nested-ternary */
import { Grid, Hidden } from "@material-ui/core";
import React from "react";
import i18next from "../../../../assets/i18n/i18n";
import { Status } from "../../../../models/account-status.model";
import AccountStatusNokLogo from "../../../../components/logos/AccountStatusNokLogo";
import AccountStatusOkLogo from "../../../../components/logos/account-status-ok";
import UserNotFoundLogo from "../../../../components/logos/user-not-found";
import "./account-status.scss";

type MyProps = {
    status: Status;
};

export default class AccountStatus extends React.Component<MyProps> {
    render(): React.ReactElement {
        const { status } = this.props;

        const statusBackgroundStyle = status === "link" || status === "newlink" ? "linked" : "notLinked";
        return (
            <Grid container className={statusBackgroundStyle}>
                <Grid item xs>
                    <Grid container spacing={1}>
                        <Grid item xs>
                            {status === "link" || status === "newlink" ? (
                                <AccountStatusOkLogo />
                            ) : status === "unlink" || status === "notlink" ? (
                                <AccountStatusNokLogo />
                            ) : (
                                <UserNotFoundLogo />
                            )}
                        </Grid>
                        <Grid container item xs={status === "notfound" ? 6 : status === "link" ? 7 : 8}>
                            <Grid
                                item
                                xs
                                className={
                                    status === "link"
                                        ? "link-label"
                                        : status === "unlink"
                                        ? "unlink-label"
                                        : status === "notlink"
                                        ? "not-link-label"
                                        : status === "newlink"
                                        ? "new-link-label"
                                        : "not-found-label"
                                }
                            >
                                <p className="account-status-label">
                                    {i18next.t(
                                        `AccountStatus.${
                                            status === "link"
                                                ? "Link"
                                                : status === "unlink"
                                                ? "Unlink"
                                                : status === "notlink"
                                                ? "NotLink"
                                                : status === "newlink"
                                                ? "NewLink"
                                                : "NotFound"
                                        }`,
                                    )}
                                </p>
                            </Grid>
                        </Grid>

                        <Hidden smDown>
                            <Grid item xs />
                        </Hidden>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}
